import baseComponent from 'BASE/components/chat/chat.base.component'
import room_list_classification from 'XC/components/chat/chat.component.roomListClassification'
import room from "XC/components/chat/chat.component.room"
import room_window from 'XC/components/chat/chat.component.roomWindow'
import multicast_descendant from 'BASE/components/chat/chat.base.component.multicastDescendant'
import add_group_room_dialog from 'BASE/components/chat/chat.base.component.addGroupRoomDialog'
import set_group_room_name_dialog from 'BASE/components/chat/chat.base.component.setGroupRoomNameDialog'
import join_group_room_dialog from 'BASE/components/chat/chat.base.component.joinGroupRoomDialog'

import SETTING from 'BASE/common/chat/chat.setting'
import CONSTANT from 'BASE/common/chat/chat.constant'
import { actionTypes } from 'BASE/store/types'

export default {
    mixins: [baseComponent],
    components: {
        room_list_classification,
        room,
        room_window,
        multicast_descendant,
        add_group_room_dialog,
        set_group_room_name_dialog,
        join_group_room_dialog
    },
    data: function () {
        return {
            activedTab: 1,
            isFoldOut: {
                searchRoom: true,
                leftOnTalk: true,
                rightOnTalk: true,
                leftOnTalkGroupRooms: true,
                rightOnTalkGroupRooms: true,
            },
            isMinimizeDragWindow: false,
            minimizeInfo: {
                title: '',
                roomId: '',
                onTalkTime: undefined
            },
            showChatIcon: true,
        }
    },
    methods: {
        clickTab(newTab) {
            if (newTab === this.activedTab) {
                return;
            }
            this.activedTab = newTab;
        },
        closeDragWindow(){   
            this.isMinimizeDragWindow = false;
            this.$store.dispatch(actionTypes.CHAT_CLOSE_ROOM_WINDOW, {
                roomId: this.minimizeInfo.roomId,
                onTalkTime:this.minimizeInfo.onTalkTime
            });
        },
        minimizeDragWindow(){
            this.isMinimizeDragWindow = true;
            this.$store.dispatch(actionTypes.CHAT_CLOSE_ROOM_WINDOW, {
                roomId: this.minimizeInfo.roomId,
                onTalkTime:this.minimizeInfo.onTalkTime //縮小時不從當前聯繫列表移除，因此需增加talkTime
            });
        },
        maximizeDragWindow(){
            this.isMinimizeDragWindow = false;
            this.$store.dispatch(actionTypes.CHAT_OPEN_ROOM_WINDOW, {
                roomId: this.minimizeInfo.roomId,
            });
        },
        showMulticastDescendantsDialog() {
            let dialog = this.$dialog.get('multicastDescendants');
            dialog.$on('close', async (result) => {
                let isSuccess = result.isSuccess;
                if (isSuccess) {
                    this.$dialog.warning("群组广播成功!");
                }
            });
            dialog.show();
        },
        addGroupRoomDialog() {
            this.$dialog.get("addGroupRoom").show();
        },
        sortTalkRooms(talkRooms) {
            return talkRooms.sort(function (a, b) {
                if (a.onTalkTime < b.onTalkTime)
                    return -1;
                if (a.onTalkTime > b.onTalkTime)
                    return 1;
                return 0;
            });
        }
    },
    computed: {
        popWindows: function () {
            return this.$store.state.chat.roomWindows;
        },
        unreadCountSum: function () {
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.type === CONSTANT.roomType.ANCESTOR || item.type === CONSTANT.roomType.DESCENDANT) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        groupCountSum: function () {
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.type === CONSTANT.roomType.DESCENDANT_GROUP) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        roomSum: function () {
            return this.$store.state.chat.rooms.filter((item) => {
                if (item.type === CONSTANT.roomType.CUSTOMER_SERVICE
                    || item.type === CONSTANT.roomType.ANCESTOR
                    || item.type === CONSTANT.roomType.DESCENDANT) {
                    return true;
                }
                return false;
            }).length;
        },
        minRoomName(){
            let minRoomId = this.minimizeInfo.roomId;
            let minRoom = this.$store.state.chat.rooms.find((item) => item.id == minRoomId);
            return minRoom ? minRoom.name : "";
        },
        minimizeTitle(){
            let title = "";
            let currentWindow = this.popWindows.find((item) => item.showTime);
            if(currentWindow){
                title = currentWindow.room.name;
                this.minimizeInfo.title = title;
                this.minimizeInfo.roomId = currentWindow.room.id;
                this.minimizeInfo.onTalkTime = currentWindow.room.onTalkTime;
                return title;
            }

            return this.minRoomName;    //當群組名即時變更時需動態變更
        },
        isShowDragWindow(){
            let currentWindow = this.$store.state.chat.roomWindows.find((item) => item.showTime);
            if(currentWindow){
                this.isMinimizeDragWindow = false;
                return true
            }
            return false;
        },
        onTalkUnreadCountSum(){
            var sum = 0;
            this.$store.state.chat.rooms.forEach((item) => {
                if (item.onTalkTime) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        onTalkGroupRooms(){
            let onTalkGroupRooms = this.$store.state.chat.rooms.filter((item) => {
                return item.onTalkTime && (item.type === CONSTANT.roomType.DESCENDANT_GROUP);
            });
            return this.sortTalkRooms(onTalkGroupRooms);
        },
        onTalkGroupRoomsUnreadCountSum(){
            var sum = 0;
            this.onTalkGroupRooms.forEach((item) => {
                if (item.onTalkTime) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        onTalkRooms(){
            let onTalkRooms = this.$store.state.chat.rooms.filter((item) => {
                return item.onTalkTime && (item.type === CONSTANT.roomType.DESCENDANT);
            });
            return this.sortTalkRooms(onTalkRooms);
        },
        onTalkDescendantUnreadCountSum(){
            var sum = 0;
            this.onTalkRooms.forEach((item) => {
                if (item.onTalkTime) {
                    sum += item.unreadCount;
                }
            });
            return sum;
        },
        onTalkOnlineCount(){
            return this.$store.state.chat.roomMemberContainers.filter((item) => {
                return item.room.type === CONSTANT.roomType.DESCENDANT && item.room.onTalkTime && item.roomMembers && item.roomMembers[0].isOnline;
            }).length;
        },
        descendantOnlineCount(){
            return this.$store.state.chat.roomMemberContainers.filter((item) => {
                return item.room.type === CONSTANT.roomType.DESCENDANT && item.roomMembers && item.roomMembers[0].isOnline;
            }).length;
        },
        currentRoomId(){
            let currentWindow = this.$store.state.chat.roomWindows.find((item) => item.showTime);
            if(currentWindow)
                return currentWindow.room.id;
            return undefined;
        },
    },
    watch: {
        "$route.name": function (val, oldVal) {
            this.showChatIcon = true;
            if(val == "DrawHistory"){
                this.showChatIcon = false;
            }
        }
    },
    created: function () {
        SETTING.messages.CUSTOMER_SERVICE_WAITING = () => `正在等待客服坐席分配`;
        SETTING.GROUP_ROOM_NAME_MAX_SIZE = 20;  //TY群組名最長20字
    },
};